import { render, staticRenderFns } from "./UpdateDetail.vue?vue&type=template&id=bc7b038e&scoped=true"
import script from "./UpdateDetail.vue?vue&type=script&lang=js"
export * from "./UpdateDetail.vue?vue&type=script&lang=js"
import style0 from "./UpdateDetail.vue?vue&type=style&index=0&id=bc7b038e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7b038e",
  null
  
)

export default component.exports